/**
 * api end-points
 */
export const END_POINTS = {
    cardInfo: 'charge/card/info',
    paymentData: 'charge/token',
    pay: 'pay'
}

/**
 * api response codes
 */
export const API_RESPONSE_CODES = {
    QRCODE_TRANSFER_MODE: 101,
    QRCODE_SHOP_MODE: 102,
    QRCODE_Login_MODE: 103,
    QRCODE_TERMINAL_MODE: 104,
    SUCCESS: 200,
    FILL_FIELD: 201,
    NOT_ENOUGH_MONEY: 401,
    USERNAME_OR_PASSWORD_WRONG: 300,
    DUPLICATE: 301,
    WRONG_VERIFY_CODE: 302,
    NOT_FOUND: 303,
    USER_NOT_ACTIVATED: 304,
    WRONG_VERIFY: 305,
    NO_DEVICE_TYPE: 306,
    USER_NOT_VERIFIED: 307,
    URL_NOT_FOUND: 404,
    SERVER_ERROR: 500,
    SMS_CENTER_DOWN: 601,
}

/**
 * constant api response messages
 */
export const API_RESPONSE_MESSAGES = {
    SERVER_CONNECTION_ERROR: 'ارتباط با سرور برقرار نشد',
    INTERNAL_SERVER_ERROR: 'سرور با خطا مواجه شده است'
}